import React from 'react';
import TableBase, { Props as TableProps } from './Base';
import {
  convertArrayCapitalizeFirstLetter,
  convertStringCapitalizeFirstLetter,
  DateFormat,
  handleGetCoShareValue,
} from '../../../utils/global';
import './Films.scss';
import { SupplierI } from '../../../interfaces/supplier';
import { CurrentUserI } from '../../../interfaces/auth';
import { LicenseI } from '../../../interfaces/license';
import { TerritoryI } from '../../../interfaces/territory';
import { TerritoryRights } from '../../../pages/film/components/TerritoryRights';

type Props = TableProps & {
  withAction?(_: any): void;
  dataSource?: any[];
  currentUser?: CurrentUserI;
};

const FilmsTable: React.FC<Props> = ({ dataSource, withAction, currentUser, ...props }) => {
  const COLUMNS = [
    {
      title: 'Title',
      dataIndex: 'title',
      width: 150,
      sorter: true,
      render: (title: string, record: any) => {
        return (
          <span className="text-uppercase">
            {title} {record.titleCN && `《 ${record.titleCN} 》`}{' '}
          </span>
        );
      },
    },
    {
      title: 'License Period',
      width: 200,
      render: (film: any) => {
        return (
          <span className="value">
            {DateFormat(film?.licenseStartDate)} - {DateFormat(film?.licenseEndDate)}
          </span>
        );
      },
    },
    {
      title: 'Co Share',
      width: 100,
      render: (film: any) => {
        return <span>{handleGetCoShareValue(film, currentUser).join(', ')}</span>;
      },
    },
    {
      title: 'Supplier',
      dataIndex: 'supplier',
      width: 100,
      render: (supplier: SupplierI) => {
        return <span>{supplier?.name}</span>;
      },
    },
    {
      title: 'Films Rights',
      dataIndex: 'territories',
      width: 300,
      render: (territories: TerritoryI[]) => {
        return (
          <ul>
            {territories?.map((territory: TerritoryI) => (
              <li key={territory.id}>
                <h2 style={{ fontSize: 14, marginBottom: 5 }}>
                  {territory.name ? convertArrayCapitalizeFirstLetter(territory.name) : ''}
                </h2>
                <div>
                  {territory?.exclusiveRights && Object.keys(territory?.exclusiveRights).length > 0 && (
                    <div className="item2">
                      <label>Exclusive Rights</label>
                      <TerritoryRights rights={territory?.exclusiveRights} />
                    </div>
                  )}
                  {territory?.nonExclusiveRights && Object.keys(territory?.nonExclusiveRights).length > 0 && (
                    <div className="item2">
                      <label>Non Exclusive Rights</label>
                      <TerritoryRights rights={territory?.nonExclusiveRights} />
                    </div>
                  )}
                </div>
              </li>
            ))}
          </ul>
        );
      },
    },
    {
      title: 'Licenses Sold',
      dataIndex: 'soldLicenses',
      width: 300,
      render: (soldLicenses: LicenseI[]) => {
        return soldLicenses?.map((license: LicenseI) => (
          <ul key={license?.id}>
            {license?.licenseTerritories?.map((territory: any) => {
              const formattedTerritoryName = territory.name ? convertStringCapitalizeFirstLetter(territory.name) : '';
              return (
                <li key={territory.id}>
                  <h2 style={{ fontSize: 14, marginBottom: 5 }}>{formattedTerritoryName}</h2>
                  <div>
                    {territory?.exclusiveRights && Object.keys(territory?.exclusiveRights).length > 0 && (
                      <div className="item2">
                        <label>Exclusive Rights</label>
                        <TerritoryRights rights={territory?.exclusiveRights} />
                      </div>
                    )}
                    {territory?.nonExclusiveRights && Object.keys(territory?.nonExclusiveRights).length > 0 && (
                      <div className="item2">
                        <label>Non Exclusive Rights</label>
                        <TerritoryRights rights={territory?.nonExclusiveRights} />
                      </div>
                    )}
                  </div>
                </li>
              );
            })}
          </ul>
        ));
      },
    },
  ];

  if (withAction) {
    COLUMNS.push({
      key: 'action',
      width: 50,
      fixed: 'right' as unknown as boolean,
      render(record: any) {
        return withAction(record);
      },
    } as any);
  }
  return <TableBase dataSource={dataSource} columns={COLUMNS} scroll={{ x: '100%' }} {...props} />;
};

export default FilmsTable;
